module.exports = __webpack_public_path__ + "img/nb-7.f98c9eb6.png";